"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../constants/constants");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const contactSupportButton_1 = __importDefault(require("../../components/contactSupportButton/contactSupportButton"));
const openExternalLink_1 = __importDefault(require("../../components/openExternalLink/openExternalLink"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const statementsProvider_1 = require("../../providers/statementsProvider");
const monoCard_1 = __importDefault(require("../../components/monoCard/monoCard"));
const manualBankAccount_1 = __importDefault(require("./manualBankAccount/manualBankAccount"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const homeSlice_1 = require("../home/homeSlice");
const icon_1 = require("../../components/icon/icon");
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../../components/text/text"));
const myBankStatement_1 = __importDefault(require("../myBankStatement/myBankStatement"));
const providerCard_1 = __importDefault(require("../../components/providerCard/providerCard"));
const analytics_1 = require("../../utils/analytics/analytics");
const LoanApplicationUpdateStatements = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [currentProvider, setCurrentProvider] = (0, react_1.useState)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [canContinueProcess, setCanContinueProcess] = (0, react_1.useState)(false);
    const [returnErrors, setReturnErrors] = (0, react_1.useState)();
    const navigation = (0, useAppNavigation_1.default)();
    const { getProviderAux } = (0, react_1.useContext)(statementsProvider_1.StatementsContext);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        if (!currentProvider) {
            getProviderAux(dispatch, { currentProvider, setCurrentProvider }, logEventWithExtraProperties);
        }
        setIsLoading(false);
    }, []);
    let supportButtonContent = react_1.default.createElement(react_native_1.View, null);
    if (currentProvider === constants_1.BANK_STATEMENT_MANUAL) {
        supportButtonContent = (react_1.default.createElement(contactSupportButton_1.default, { onPress: () => (0, openExternalLink_1.default)({
                url: 'https://lendigo.ng/contact-lendigo/',
                webViewData: {
                    sourcePage: screenConstants_1.LOAN_APPLICATION_UPDATE_STATEMENTS_SCREEN,
                    sourceScreen: 'providers',
                    name: 'contactSupport',
                    title: 'Contact Support',
                },
                navigation,
            }), text: "Contact Support", hasIcon: true, eventName: "bank_statement_contact_support" }));
    }
    else {
        supportButtonContent = (react_1.default.createElement(contactSupportButton_1.default, { onPress: () => setCurrentProvider(constants_1.BANK_STATEMENT_MANUAL), text: "Unable to Connect Bank Statement?", hasIcon: false, eventName: "change_statement_provider" }));
    }
    const continueProcess = () => {
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: 'Upload successfully',
                message: 'Your statement of account upload was successful. We will notify you on your loan progress shortly. Thank you.',
                iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                iconColor: '',
                iconSize: 55,
                buttonText: 'Continue',
                hasLogo: false,
                actionButton: () => {
                    // TODO REVIEW THIS
                    //  get next message in missing loan application data
                    // dispatch(showMessage());
                    navigation.navigate(screenConstants_1.HOME_SCREEN);
                },
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    };
    const finishedMBS = () => {
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: 'Connected successfully',
                message: 'Your connection with MyBankStatement was successful. We will notify you on your loan progress shortly. Thank you.',
                iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                iconColor: '',
                iconSize: 55,
                buttonText: 'Continue',
                hasLogo: false,
                actionButton: () => {
                    // TODO REVIEW THIS
                    // get next message in missing loan application data
                    // dispatch(showMessage());
                    navigation.navigate(screenConstants_1.HOME_SCREEN);
                },
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    };
    const safeProcessMessage = (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12 }, "*Uploading your bank statement automatically with any of the options above is a safe process and we only require this information to check and confirm your eligibility for a loan")));
    const mybankStatement = 'mybankStatement';
    (0, react_1.useEffect)(() => {
        if (returnErrors) {
            setCurrentProvider(constants_1.BANK_STATEMENT_PROVIDER_MONO);
        }
    }, [returnErrors]);
    // we are passing errors from MBS to here to display if it fails.
    // if current provider changes we want to clean the errors so they won't show for the 2 other options
    (0, react_1.useEffect)(() => {
        if (currentProvider === constants_1.BANK_STATEMENT_MANUAL || currentProvider === constants_1.BANK_STATEMENT_MBS) {
            setErrors(undefined);
        }
    }, [currentProvider]);
    return (react_1.default.createElement(navContainer_1.default, { isLoading: isLoading, errors: errors, childrenTitle: "Bank Account Information", footer: currentProvider === constants_1.BANK_STATEMENT_MANUAL && (react_1.default.createElement(primaryButton_1.default, { title: "Submit", onPress: continueProcess, eventName: "add_bank_account_save", disabled: !canContinueProcess })) },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
            currentProvider === constants_1.BANK_STATEMENT_PROVIDER_MONO && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.centerChildHorizontalVertical,
                        styles_1.default.minimumMarginBetweenElementsVertically,
                    ] },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('submit_account_details.automatic_statements'))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                    react_1.default.createElement(monoCard_1.default, null)),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.minimumMarginBetweenElementsVertically] }),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                    react_1.default.createElement(providerCard_1.default, { onPress: () => setCurrentProvider(constants_1.BANK_STATEMENT_MBS), logo: react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: { fontWeight: 'bold' } }, mybankStatement)), isConnected: false, eventName: "statement_select_my_bank_statement" })),
                safeProcessMessage)),
            currentProvider === constants_1.BANK_STATEMENT_MBS && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(myBankStatement_1.default, { errors: errors, setErrors: setErrors, setCanContinueProcess: finishedMBS, setReturnError: setReturnErrors }))),
            currentProvider === constants_1.BANK_STATEMENT_MANUAL && (react_1.default.createElement(manualBankAccount_1.default, { errors: errors, setErrors: setErrors, setCanContinueProcess: setCanContinueProcess }))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.justifyFlexEnd] }, supportButtonContent)));
};
exports.default = LoanApplicationUpdateStatements;
